(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificates-slider"] && !Shopify.designMode) return;
  try {
    
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(function($) {
      var $slider = $('.clinical-proof-slider');

      // if ($slider.length && !$slider.hasClass('slick-initialized')) {

      //   var totalSlides = $slider.children().length;   // count slides
      //   var startIndex = Math.floor(totalSlides / 2);  // middle index

      //   $slider.slick({
      //     slidesToShow: 5,
      //     slidesToScroll: 1,
      //     arrows: false,
      //     dots: false,
      //     autoplay: false,
      //     centerMode: false,
      //     centerPadding: '60px',
      //     loop: true,
      //     initialSlide: startIndex,
      //     responsive: [
      //       {
      //         breakpoint: 768,
      //         settings: {
      //           slidesToShow: 2,
      //           autoplay: true,
      //           centerPadding: '20px'
      //         }
      //       }
      //     ]
      //   });
      // }

      // Modal logic
      var $modal = $('.certificate-modal');
      var $modalImg = $('.certificate-modal-img');
      var $closeBtn = $('.certificate-modal-close');

      // open modal
      $(document).on('click', '.certificate-btn', function(e) {
        e.preventDefault();
        var imgUrl = $(this).data('certificate'); // get certificate image
        $modalImg.attr('src', imgUrl);
        $modal.fadeIn();
      });

      // close modal
      $closeBtn.on('click', function() {
        $modal.fadeOut();
        $modalImg.attr('src', '');
      });

      // close on background click
      $modal.on('click', function(e) {
        if (e.target === this) {
          $modal.fadeOut();
          $modalImg.attr('src', '');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
      $('.custom-collection_slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
        }
      }
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn_slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
      $('.multicolumn_slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
  tab.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.dataset.bsTarget);

    document.querySelectorAll('.tab-pane').forEach((pane) => {
      pane.classList.remove('show', 'active');
    });

    document.querySelectorAll('.nav-link').forEach((link) => {
      link.classList.remove('active');
    });

    target.classList.add('show', 'active');
    this.classList.add('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
